export default {
      id: "pause-status-usage",
      viewBox: "0 0 7 10",
      url: "static/docker-35e621d613051bbda5b8b67fc5bb152e/images/" + "sprite.svg#pause-status-usage",
      toString: function () {
        return this.url;
      }
    }